import { RestLink } from 'apollo-link-rest';

export function createRestLink() {
    return new RestLink({
        uri: '/gate',
        responseTransformer: async (response) => response.json(),
    });
}
